<template>
  <div>
    <h3 class="font-medium text-m1 mb-8">Ratings & reviews</h3>
    <p class="text-grey-body my-auto pt-8">
      {{ starAggregate }} star average with {{ totalReviewCount }} {{ totalReviewCount === 1 ? 'rating' : 'ratings' }}
    </p>
    <reviews-list :reviews="reviews" :total-review-count="totalReviewCount" class="mt-16" @view-more-reviews="viewMoreHandler" />
  </div>
</template>

<script lang="ts">
import ReviewsList from '@/components/reviews_list/ReviewsList.vue';

export default {
  name: 'RatingsAndReviews',
  components: {
    ReviewsList,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      reviewsFetchCount: 3,
    };
  },
  computed: {
    reviews(): any {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.edges || [];
    },
    starAggregate(): string {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.starAggregate || '';
    },
    totalReviewCount(): number {
      return this.$store.getters['applications/applicationDetails'].sitter?.reviews?.totalReviewCount || 0;
    },
  },
  methods: {
    viewMoreHandler(): void {
      // Increase the number of displayed reviews by 3
      this.reviewsFetchCount += 3;
      this.$emit('input', this.reviewsFetchCount);
    },
  },
};
</script>
